<!-- <app-nps [ask-now]="askNps" source="job-list" subject="recommend-karpishe-general"
	[client-data]="{jobClickCount: jobClickCount}" mode="popup">
</app-nps> -->
<section class="container-capped d-flex flex-column gap-2 py-2 h-100 px-0 mr-md-0" [class.light-gray-bg]="Utility.mobile">

	<div class="" *ngIf="source?.Name">
		<div class="kp-card d-flex m-1">
			<img class="icon-xl ml-2" [alt]="source.Title +' - '+ source.Name" [src]="source.Name|favicon:128" />
			<div class="flex-grow-1 d-flex flex-column justify-content-between ">
				<h2 class="fs-normal">آگهی‌های استخدامی <b>{{source.Title}}</b></h2>
				<div class="d-flex align-items-center justify-content-between ">
					<a class="btn btn-blue btn-sm fs-sm px-3" [routerLink]="['/job', SearchParams.getParams(appliedParams)]"
						[queryParams]="SearchParams.getQueryParams(appliedParams, 'src')">
						آگهی‌های {{source.Title}}<br class="d-md-none" /> و {{sources?.length}} سایت دیگر</a>
					<a class="btn btn-secondary btn-sm fs-sm px-3" target="_blank" rel="nofollow"
						[href]="'https://' + source.Name">
						انتقال به <br class="d-md-none" /> سایت {{source.Title}}</a>
				</div>
			</div>

		</div>
	</div>

	<app-breadcrumb [breadcrumb-data]="breadcrumbData" [hide-last]="current_search ? 1 : 0 " *ngIf="current_state">
	</app-breadcrumb>

	<div class="" sticky-bar="light-gray-bg kp-header-shadow">
		<div class="container px-1 px-md-0">
			<app-search-box #searchBox [(ngModel)]="params" [showFilters]="true"></app-search-box>
		</div>
	</div>
	<div class="flex-fill d-flex overflow-hidden">
		<div class="d-md-block px-md-3 w-100 scroll-md-lg job-list-scroll overflow-auto relative" dir="ltr">
			<div dir="rtl">

				<div class="px-2 mb-1 d-flex flex-wrap align-items-center justify-content-between"
					*ngIf="!isCanonicalDifferent && searchParam">
					<div>
						<h1 class="fs-normal mb-0 px-1 border-bottom border-3 border-dark-gray">{{getTitle(searchParam)}}</h1>
					</div>
					<div class="text-left no-wrap" *ngIf="user?.Seeker?.JobAlertSettings">
						<div class="fs-sm fw-bold f-blue pointer" [routerLink]="['/seeker', 'matching']">
							<i class="fa fa-bell fs-normal ml-1"></i>
							تنظیمات گوش‌به‌زنگ
						</div>
					</div>
				</div>


				<div class="d-flex flex-column white-bg p-2 mb-1" *ngIf="!newDate && isCanonicalDifferent">
					<div class="">
						نمایش نتایج <a class="wrap f-default-link" [routerLink]="['/job', SearchParams.getParams(appliedParams)]"
							[queryParams]="SearchParams.getQueryParams(appliedParams)">
							<h1 class="h6 font-italic d-inline-block">{{getTitle(appliedParams)}}</h1>
						</a>
					</div>
					<div class="fs-sm" *ngIf="didYouMean">
						آیا منظورتان این بود؟ <a class="wrap f-default-link"
							[routerLink]="['/job', SearchParams.getParams(didYouMean)]"
							[queryParams]="SearchParams.getQueryParams(didYouMean)" queryParamsHandling="preserve">
							<h1 class="fs-sm font-italic d-inline-block">{{getTitle(didYouMean)}}</h1>
						</a>
					</div>
				</div>
				<div class="pb-1">
					<app-subscribe-search #subscribeSearch *ngIf="current_criteria" [source]="'job-list-header'"
						[params]="searchParam">
					</app-subscribe-search>

				</div>

				<div *ngIf="redirectedReason" class="kp-message kp-message-warning">
					آگهی استخدام مورد نظر دیگر در سایت وجود ندارد، آگهی‌های استخدام مشابه در پایین آمده است.
				</div>
				<div class="kp-message kp-message-warning" *ngIf="!total">
					برای جستجوی شما آگهی یافت نشد. می‌توانید جستجوهای زیر را امتحان کنید:
				</div>

				<div class="relative" [class.h-min-full]="!hasQuestion">
					<ngx-spinner name="list" [fullScreen]="false"></ngx-spinner>

					<ng-container *ngFor="let job of jobs; let i=index; trackBy:trackByFn">

						<!-- <app-questioner class="mb-2"
							*ngIf="!newDate && !searching && i==questionerPosition && !extraCards?.advertises?.length"
							[search-params]="appliedParams" (question-key)="hasQuestion=!!$event">
						</app-questioner> -->


						<ng-container *ngIf="i==questionerPosition">
							<ng-container *ngTemplateOutlet="suggesterTemplate"></ng-container>

						</ng-container>
						<!-- <ng-container *ngIf="i==questionerPosition && extraCards?.advertises?.length">
							<div class="mb-2" *ngFor="let advertise of extraCards.advertises"
								ga-event="advertise-click|seeker|{{advertise.Title || advertise.Id}}">
								<a class="f-default-link" [innerHTML]="advertise.Banner"
									[routerLink]="advertise.Link || ['/exclusive-job',advertise.Id]"
									[queryParams]="advertise.Link && advertise.SetLinkUtm ? {utm_source:'karpishe', utm_medium: 'job-ads'} : undefined"></a>
							</div>
						</ng-container> -->

						<div class="d-flex flex-column white-bg py-2 px-3 mb-2"
							*ngIf="!newDate && i==topicPosition && extraCards.topicsInline?.length">
							<a class="f-default-link" [routerLink]="['/discussion', { tags: topicTag || '' }]">
								<h5>تبادل نظر {{topicTag ? 'درباره ' + topicTag : ''}}</h5>
							</a>

							<a *ngFor="let topic of extraCards.topicsInline" class="py-1 d-flex pointer border-top"
								[routerLink]="['/discussion',topic.Id == Guid.Empty ? 'add' : topic.Id]"
								[queryParams]="topic.Id == Guid.Empty ? { topic: topic.Title, tags: topicTag || '' } : undefined">
								<div class="d-flex ml-2">
									<div class="circle light-gray-bg bg-contain" [class.icon-sm]="topic.Id==Guid.Empty"
										[class.icon-normal]="topic.Id!=Guid.Empty"
										style="background-image: url('{{topic.Message?.user?.id|avatar:28|async}}');">
									</div>
								</div>
								<div class="flex-fill overflow-hidden">
									<div class="d-flex align-items-start">
										<h6 class="fs-normal flex-fill mb-0">{{topic.Title}}</h6>
										<div class="fs-sm f-medium-gray no-wrap" *ngIf="topic.ReplyCount && topic.Id != Guid.Empty">
											<i class="fa fa-reply"></i>
											{{topic.ReplyCount|number}}
										</div>
										<div class="fs-sm dark-gray-bg f-yellow badge badge-pill m-1 no-wrap"
											*ngIf="topic.Id == Guid.Empty">
											نظر شما؟
										</div>
									</div>
									<div class="d-flex overflow-hidden" *ngIf="topic.Id != Guid.Empty">
										<div class="fs-sm f-gray flex-fill no-wrap-ellipsis">
											{{topic.Message?.body}}
										</div>
										<div class="no-wrap f-medium-gray fs-sm">
											{{(topic.Message?.registerTime || topic.UpdateTime)|pdate:'[h]:[mi]'}}
										</div>
									</div>
								</div>
							</a>
						</div>

						<div class="d-flex flex-column white-bg p-2 mb-2"
							*ngIf="!newDate && i==queriesPosition && (extraCards.queriesInline?.length || extraCards.jobTitlesInline?.length)">
							<h6 class="fw-bold">جستجوهای مرتبط</h6>
							<a class="w-100 justify-content-start border-top fs-normal py-2" target="_blank"
								*ngFor="let query of extraCards.jobTitlesInline" [routerLink]="['/job',{q: query}]">
								<i class="fa fa-search ml-2 mr-2"></i>استخدام {{query}}</a>
							<a class="w-100 justify-content-start border-top fs-normal py-2" target="_blank"
								*ngFor="let query of extraCards.queriesInline" [routerLink]="['/job',{q: query}]">
								<i class="fa fa-search ml-2 mr-2"></i>{{query}}</a>
						</div>

						<div class="d-flex flex-column white-bg p-2 mb-2"
							*ngIf="!newDate && i==relatedPagesPosition && extraCards.relatedPagesInline?.length">
							<h6 class="fw-bold">صفحات مرتبط</h6>
							<a class="w-100 justify-content-start border-top fs-normal py-2" target="_blank"
								*ngFor="let page of extraCards.relatedPagesInline" [href]="page">
								<i class="fa fa-search ml-2 mr-2"></i>{{getTitleFromUrl(page)}}</a>
						</div>

						<div *ngIf="job.IsExpired && (!i || !jobs[i-1]?.IsExpired)">
							<app-subscribe-search [source]="'job-list-expired'" [expiredPosition]="i" [params]="searchParam" >
							</app-subscribe-search>
						</div>

						<app-job-summary [id]="'job-'+job.Id" [job]="job" [favorite]="favoriteIds?.includes(job.Id)"
							(toggleFavorite)="setFavorite(job)" [newDate]="newDate" (job-click)="addJobClick()"
							[hideDateAndStatus]="job.IsPaid || job._IsSponsored || job.IsAppliable">
						</app-job-summary>
					</ng-container>

				</div>

				<div class="text-center" #loadMoreElement *ngIf="moreFrom<total && appliedParams?._mode!='fallback-expired'">
					<div class="relative text-center" style="height: 30px;">
						<ngx-spinner name="more" [fullScreen]="false" bdColor="rgba(0,0,0,0)" color="gray" type="square-jelly-box"
							size="small"></ngx-spinner>
					</div>
					<div class="btn btn-secondary mb-2" (click)="loadMore()">
						<div class="flex-grow-1">مشاهده نتایج بیشتر</div>
						<i class="fa fa-angle-down mr-2"></i>
					</div>
				</div>

				<!-- <div class="d-flex flex-column white-bg py-2 px-3 mb-2" *ngIf="extraCards.topicsEnd?.length">
					<a class="f-default-link" [routerLink]="['/discussion', { tags: topicTag || '' }]">
						<h5>تبادل نظر {{topicTag ? 'درباره ' + topicTag : ''}}</h5>
					</a>

					<div *ngFor="let topic of extraCards.topicsEnd" class="py-1 d-flex pointer border-top"
						[routerLink]="['/discussion',topic.Id == Guid.Empty ? { tags: topicTag || '' } : topic.Id]"
						[queryParams]="topic.Id == Guid.Empty ? { add: topic.Title } : undefined">
						<div class="d-flex ml-2">
							<div class="circle light-gray-bg bg-contain" [class.icon-sm]="topic.Id==Guid.Empty"
								[class.icon-normal]="topic.Id!=Guid.Empty"
								style="background-image: url('{{topic.Message?.user?.id|avatar|async}}');">
							</div>
						</div>
						<div class="flex-fill overflow-hidden">
							<div class="d-flex align-items-start">
								<h6 class="fw-normal fs-normal flex-fill mb-0">{{topic.Title}}</h6>
								<div class="fs-sm f-medium-gray no-wrap" *ngIf="topic.ReplyCount && topic.Id != Guid.Empty">
									<i class="fa fa-reply"></i>
									{{topic.ReplyCount|number}}
								</div>
								<div class="fs-sm dark-gray-bg f-yellow badge badge-pill m-1 no-wrap" *ngIf="topic.Id == Guid.Empty">
									نظر شما؟
								</div>
							</div>
							<div class="d-flex overflow-hidden" *ngIf="topic.Id != Guid.Empty">
								<div class="fs-sm f-gray flex-fill no-wrap-ellipsis">
									{{topic.Message?.body}}
								</div>
								<div class="no-wrap f-medium-gray fs-sm">
									{{(topic.Message?.registerTime || topic.UpdateTime)|pdate:'[h]:[mi]'}}
								</div>
							</div>
						</div>
					</div>
				</div> -->

				<!-- <app-questioner class="mb-2" *ngIf="!newDate && !searching && total<questionerPosition"
					[search-params]="appliedParams" (question-key)="hasQuestion=!!$event" [suggestion-page]="10">
				</app-questioner> -->
				<ng-container *ngIf="total<questionerPosition">
					<ng-container *ngTemplateOutlet="suggesterTemplate"></ng-container>
				</ng-container>


				<div
					*ngIf="!newDate && (extraCards.searchParam || extraCards.queriesEnd?.length || (extraCards.relatedPagesEnd|keyvalue)?.length)"
					class="d-flex flex-column white-bg p-2 mb-2">
					<h6 class="fw-bold">صفحات و جستجوهای مرتبط</h6>

					<a class="w-100 justify-content-start border-top fs-normal py-2" target="_blank"
						*ngFor="let query of extraCards.queriesEnd" [routerLink]="[ '/job',{q: query}]">
						<i class="fa fa-search ml-2 mr-2"></i>{{query}}</a>

					<a class="w-100 justify-content-start border-top fs-normal py-2" target="_blank"
						*ngFor="let page of extraCards.relatedPagesEnd" [href]="page">
						<i class="fa fa-search ml-2 mr-2"></i>{{getTitleFromUrl(page)}}</a>

					<ng-container *ngIf="extraCards.searchParam">
						<a class="w-100 justify-content-start border-top fs-normal py-2" *ngIf="searchParam.city"
							[routerLink]="['/job',{q: searchParam.q, l:Utility.locationSearch(searchParam.state, undefined)}]">
							<i class="fa fa-search ml-2 mr-2"></i>{{getTitle({q:searchParam.q, state: searchParam.state})}}</a>
						<a class="w-100 justify-content-start border-top fs-normal py-2" *ngIf="searchParam.state"
							[routerLink]="['/job',{q: searchParam.q}]">
							<i class="fa fa-search ml-2 mr-2"></i>{{getTitle({q:searchParam.q})}}</a>
						<a class="w-100 justify-content-start border-top fs-normal py-2" *ngIf="searchParam.city"
							[routerLink]="['/job',{l:Utility.locationSearch(searchParam.state, searchParam.city)}]">
							<i class="fa fa-search ml-2 mr-2"></i>{{getTitle({state: searchParam.state, city: searchParam.city})}}</a>
						<a class="w-100 justify-content-start border-top fs-normal py-2" *ngIf="searchParam.state"
							[routerLink]="['/job',{l:Utility.locationSearch(searchParam.state, undefined)}]">
							<i class="fa fa-search ml-2 mr-2"></i>{{getTitle({state: searchParam.state})}}</a>
						<a class="w-100 justify-content-start border-top fs-normal py-2" [routerLink]="['/job']">
							<i class="fa fa-search ml-2 mr-2"></i>{{getTitle({})}}</a>
					</ng-container>
				</div>

				<div class="mb-2" *ngIf="!newDate && current_criteria && jobs?.length>10">
					<app-subscribe-search [source]="'job-list-footer'" [params]="searchParam">
					</app-subscribe-search>
				</div>

				<div class="kp-questioner mb-2 py-2 px-3 relative" *ngIf="!newDate && hasQuestion && moreFrom>limit">
					<div class="border-dark-gray pb-1">
						<div class="d-flex align-items-center">
							<i class="fa fa-robot fs-xl ml-2"></i>
							<h6 class="flex-fill mb-0 blink-x">عجیبه! هنو کار پیدا نکردی؟</h6>
						</div>
						<div class="fs-sm lh-sm">
							سوال‌های
							<b>«<i class="fa fa-robot"></i>
								موتور جستجوی هوشمند کارپیشه» </b>
							رو جواب بده تا آگهی‌های دقیقتر و شخصی شده‌ی خودت رو بهت نشون بده
						</div>
						<div class="w-100 text-left">
							<div class="btn btn-sm btn-primary" (click)="scrollToQuestioner()">
								<i class="fa fa-robot"></i>
								&nbsp;باشه
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
</section>

<ng-template #suggesterTemplate>
	<app-suggester class="mb-2" *ngIf="!newDate && !searching && appliedParams" (question-key)="hasQuestion=!!$event"
		[appliedParams]="appliedParams"></app-suggester>
</ng-template>